import request from '@/utils/request'

const addressURl = {
    websiteMapList: '/website-map/list',
    websiteMapCreate: '/website-map/create',
    websiteMapUpdate: '/website-map/update',
    websiteMapDelete: '/website-map/delete',
    websiteMapDetailList: '/website-map-detail/list',
    addressView: '/branch-office-address/view',
    websiteMapDetailCreate: '/website-map-detail/create',
    websiteMapDetailUpdate: '/website-map-detail/update',
    websiteMapDetailDelete: '/website-map-detail/delete',
    mapArticleSync: '/website-map-detail/article-sync',
    websiteMapLocList: '/website-map-loc/list',
    websiteMapLocCreate: '/website-map-loc/create',
    websiteMapLocUpdate: '/website-map-loc/update',
    websiteMapLocDelete: '/website-map-loc/delete',
    mapDetailSyncXml: '/website-map-detail/sync-xml'
}

// 网站地图-列表
export function websiteMapList(data) {
    return request({
        url: addressURl.websiteMapList,
        method: 'post',
        data
    })
}

// 网站地图-创建
export function websiteMapCreate(data) {
    return request({
        url: addressURl.websiteMapCreate,
        method: 'post',
        data
    })
}

// 网站地图-更新
export function websiteMapUpdate(data) {
    return request({
        url: addressURl.websiteMapUpdate,
        method: 'post',
        data
    })
}

// 网站地图-删除
export function websiteMapDelete(data) {
    return request({
        url: addressURl.websiteMapDelete,
        method: 'post',
        data
    })
}
// 网站地图详情-列表
export function websiteMapDetailList(data) {
    return request({
        url: addressURl.websiteMapDetailList,
        method: 'post',
        data
    })
}

// 网站地图详情-创建 /api/website-map-detail/create
export function websiteMapDetailCreate(data) {
    return request({
        url: addressURl.websiteMapDetailCreate,
        method: 'post',
        data
    })
}

// 网站地图详情-更新 /api/website-map-detail/update
export function websiteMapDetailUpdate(data) {
    return request({
        url: addressURl.websiteMapDetailUpdate,
        method: 'post',
        data
    })
}
// 网站地图详情-更新 /api/website-map-detail/delete
export function websiteMapDetailDelete(data) {
    return request({
        url: addressURl.websiteMapDetailDelete,
        method: 'post',
        data
    })
}
// 网站地图详情_文章同步 /api/website-map-detail/article-sync
export function mapArticleSync(data) {
    return request({
        url: addressURl.mapArticleSync,
        method: 'post',
        data
    })
}
// 网站地图详情-同步XML /api/website-map-detail/sync-xml
export function mapDetailSyncXml(data) {
    return request({
        url: addressURl.mapDetailSyncXml,
        method: 'post',
        data
    })
}
// 网站地图链接规则-列表 /api/website-map-loc/list
export function websiteMapLocList(data) {
    return request({
        url: addressURl.websiteMapLocList,
        method: 'post',
        data
    })
}

// 网站地图链接规则-创建 /api/website-map-loc/create
export function websiteMapLocCreate(data) {
    return request({
        url: addressURl.websiteMapLocCreate,
        method: 'post',
        data
    })
}

// 网站地图链接规则-更新 /api/website-map-loc/update
export function websiteMapLocUpdate(data) {
    return request({
        url: addressURl.websiteMapLocUpdate,
        method: 'post',
        data
    })
}

// 网站地图链接规则-删除
export function websiteMapLocDelete(data) {
    return request({
        url: addressURl.websiteMapLocDelete,
        method: 'post',
        data
    })
}
export default {
    websiteMapList,
    websiteMapCreate,
    websiteMapUpdate,
    websiteMapDelete,
    websiteMapDetailList,
    websiteMapDetailCreate,
    websiteMapDetailUpdate,
    websiteMapDetailDelete,
    mapArticleSync,
    websiteMapLocList,
    websiteMapLocCreate,
    websiteMapLocUpdate,
    websiteMapLocDelete,
    mapDetailSyncXml
}
